// extracted by mini-css-extract-plugin
export default {"root":"jO1u6nIMSH"};